import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import { ProtectedRoute } from './components/access-control/ProtectedRoute';
import { SmartRedirect } from './components/access-control/SmartRedirect';
import { Layout } from './components/layout/Layout';
import { FrameOrderTrackingPage } from './pages/FrameOrderTrackingPage';
import { SlowNoMoverPage } from './pages/SlowNoMoverPage';
import { AgedStockByLotPage } from './pages/AgedStockByLotPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { PermissionMatrixPage } from './pages/PermissionMatrixPage';
import { SalesTeamConfigPage } from './pages/SalesTeamConfigPage';
import { SupplierPmConfigPage } from './pages/SupplierPmConfigPage';
import { FinancialStatementPage } from './pages/FinancialStatementPage';
import { SalesControllingPage } from './pages/SalesControllingPage';
import TrainingLogPage from './pages/TrainingLogPage';
import BankBalancePage from './pages/BankBalancePage';
import BankBalanceWeeklyPage from './pages/BankBalanceWeeklyPage';
import CashCockpitPage from './pages/CashCockpitPage';
import MsdsCoverpagePage from './pages/MsdsCoverpagePage';
import { SdsAssistantPage } from './pages/SdsAssistantPage';
import { PureSearchPage } from './pages/PureSearchPage';
import { Customer360Moved } from './pages/Customer360Moved';
import { PurchaseReportingPage } from './pages/PurchaseReportingPage';
import CompanyCarsPage from './pages/CompanyCarsPage';
import { CreditLimitsPage } from './pages/CreditLimitsPage';
import { CreditNotesPage } from './pages/CreditNotesPage';
import { VendorCostAnalysisPage } from './pages/VendorCostAnalysisPage';
import { VisitReportPage } from './pages/VisitReportPage';
import { SpcClassificationPage } from './pages/SpcClassificationPage';
import PayrollReviewPage from './pages/PayrollReviewPage';
import { SupplierOrderManagementMoved } from './pages/SupplierOrderManagementMoved';
import { PaymentReconciliationPage } from './pages/PaymentReconciliationPage';
import { AccountsReceivablePage } from './pages/AccountsReceivablePage';
import { ExpenseCapturePage } from './pages/ExpenseCapturePage';
import { ExpenseManagementPage } from './pages/ExpenseManagementPage';
import { LohnBuchungsbelegPage } from './pages/LohnBuchungsbelegPage';
import { MarginCorrectionsPage } from './pages/MarginCorrectionsPage';
import { BabReportPage } from './pages/BabReportPage';
import { BabBscCostsPage } from './pages/BabBscCostsPage';
import { ConsolidatedBusinessPage } from './pages/ConsolidatedBusinessPage';
import { PowerBiUsagePage } from './pages/PowerBiUsagePage';
import { AppUsagePage } from './pages/AppUsagePage';
import { DocuWareInvoicesPage } from './pages/DocuWareInvoicesPage';
import VatReportingPage from './pages/VatReportingPage';
import { CustomerDuplicates } from './pages/CustomerDuplicates';
import { TimeRocketHoursPage } from './pages/TimeRocketHoursPage';
import { StrategicKpisPage } from './pages/StrategicKpisPage';
import { NoticesPage } from './pages/NoticesPage';

function App() {
    return (
        <AuthProvider>
            <ToastProvider>
            <BrowserRouter>
                <Routes>
                    {/* Protected routes with layout */}
                    <Route element={<ProtectedRoute />}>
                        <Route element={<Layout />}>
                            <Route path="/frame-order-tracking" element={<FrameOrderTrackingPage />} />
                            <Route path="/slow-no-mover" element={<SlowNoMoverPage />} />
                            <Route path="/aged-stock" element={<AgedStockByLotPage />} />
                            <Route path="/consolidated-business" element={<ConsolidatedBusinessPage />} />
                            <Route path="/powerbi-usage" element={<PowerBiUsagePage />} />
                            <Route path="/app-usage" element={<AppUsagePage />} />
                            <Route path="/docuware-invoices" element={<DocuWareInvoicesPage />} />
                            <Route path="/vat-reporting" element={<VatReportingPage />} />
                            <Route path="/bab-report" element={<BabReportPage />} />
                            <Route path="/bab-bsc-costs" element={<BabBscCostsPage />} />
                            <Route path="/financial-statement" element={<FinancialStatementPage />} />
                            <Route path="/sales-controlling" element={<SalesControllingPage />} />
                            <Route path="/margin-corrections" element={<MarginCorrectionsPage />} />
                            <Route path="/sales-team-config" element={<SalesTeamConfigPage />} />
                            <Route path="/supplier-pm-config" element={<SupplierPmConfigPage />} />
                            <Route path="/training-log" element={<TrainingLogPage />} />
                            <Route path="/bank-balance" element={<BankBalancePage />} />
                            <Route path="/bank-balance/weekly" element={<BankBalanceWeeklyPage />} />
                            <Route path="/payment-reconciliation" element={<PaymentReconciliationPage />} />
                            <Route path="/accounts-receivable" element={<AccountsReceivablePage />} />
                            <Route path="/customer-duplicates" element={<CustomerDuplicates />} />
                            <Route path="/timerocket-hours" element={<TimeRocketHoursPage />} />
                            <Route path="/strategic-kpis" element={<StrategicKpisPage />} />
                            <Route path="/notices" element={<NoticesPage />} />
                            <Route path="/expense-capture" element={<ExpenseCapturePage />} />
                            <Route path="/expense-management" element={<ExpenseManagementPage />} />
                            <Route path="/lohn-buchungsbeleg" element={<LohnBuchungsbelegPage />} />
                            <Route path="/cash-cockpit" element={<CashCockpitPage />} />
                            <Route path="/msds-coverpage" element={<MsdsCoverpagePage />} />
                            <Route path="/sds-assistant" element={<SdsAssistantPage />} />
                            <Route path="/pure-search" element={<PureSearchPage />} />
                            <Route path="/purchase-reporting" element={<PurchaseReportingPage />} />
                            <Route path="/company-cars" element={<CompanyCarsPage />} />
                            <Route path="/credit-limits" element={<CreditLimitsPage />} />
                            <Route path="/credit-notes" element={<CreditNotesPage />} />
                            <Route path="/spc-classification" element={<SpcClassificationPage />} />
                            <Route path="/vendor-cost-analysis" element={<VendorCostAnalysisPage />} />
                            <Route path="/payroll-review" element={<PayrollReviewPage />} />
                            <Route path="/visit-report" element={<VisitReportPage />} />
                            <Route path="/visit-report/:draftId" element={<VisitReportPage />} />
                            <Route path="/settings/users" element={<UserManagementPage />} />
                            <Route path="/settings/permissions" element={<PermissionMatrixPage />} />
                            {/* Redirect old /settings to users sub-page */}
                            <Route path="/settings" element={<Navigate to="/settings/users" replace />} />
                        </Route>
                    </Route>

                    {/* Customer 360 moved to customer360.dolderapps.com on 2026-09-21
                        (P8a, D10). Outside ProtectedRoute and outside Layout on purpose:
                        the redirect should not wait for a sign-in round trip, and it
                        should not paint a navigation the user is about to leave. */}
                    <Route path="/customer-360" element={<Customer360Moved />} />

                    {/* Supplier Order Management moved to som.dolderapps.com on 2026-09-24
                        (SOM P7, D12). Outside ProtectedRoute and Layout for the same reasons
                        as /customer-360 above. Both pages keep their paths over there. */}
                    <Route path="/supplier-order-management" element={<SupplierOrderManagementMoved path="/supplier-order-management" />} />
                    <Route path="/som-product-master" element={<SupplierOrderManagementMoved path="/som-product-master" />} />

                    {/* Redirect to last visited or first accessible page */}
                    <Route path="/" element={<SmartRedirect />} />

                    {/* Catch-all redirect */}
                    <Route path="*" element={<SmartRedirect />} />
                </Routes>
            </BrowserRouter>
            </ToastProvider>
        </AuthProvider>
    );
}

export default App;
